/**
 * AndVPie - 饼图组件
 * 基于 Ant Design Charts Pie
 */
import React from 'react';
import { Pie } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVPieProps } from '../base/types';

// 默认示例数据（设计器中展示）
const DEFAULT_PIE_DATA = [
  { type: '分类一', value: 27 },
  { type: '分类二', value: 25 },
  { type: '分类三', value: 18 },
  { type: '分类四', value: 15 },
  { type: '分类五', value: 10 },
  { type: '其他', value: 5 },
];

// 使用 HOC 包装基础 Pie 组件
const PieWithBase = withBaseChart<AndVPieProps>(Pie, {
  chartType: 'AndVPie',
  defaultHeight: 300,
  defaultData: DEFAULT_PIE_DATA,
});

/**
 * AndVPie 饼图组件
 * 用于展示各分类占比情况，适用于展示部分与整体的关系
 */
export const AndVPie: React.FC<AndVPieProps> = (props) => {
  const {
    angleField = 'value',
    colorField = 'type',
    radius = 0.8,
    innerRadius,
    ...baseProps
  } = props;

  const chartProps: Record<string, any> = {
    ...baseProps,
    angleField,
    colorField,
    radius,
  };

  // 设置内半径时变为环形图
  if (innerRadius !== undefined && innerRadius > 0) {
    chartProps.innerRadius = innerRadius;
  }

  return <PieWithBase {...chartProps} />;
};

export type { AndVPieProps };
export default AndVPie;
